import DTO from './DTO';

class VehicleRegistryDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'vehicle_lpn',
        type: String,
        validators: [],
        labelKey: 'vehicle_lpn.short',
      },
      {
        name: 'driver_name',
        type: String,
        validators: [],
        labelKey: 'driver_name',
      },
      {
        name: 'start_date_time',
        type: String,
        validators: [],
        labelKey: 'start_date_time',
      },
      {
        name: 'vehicle_status',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'updated_at',
        type: String,
        validators: [],
        labelKey: 'last_update',
      },
      {
        name: 'in_registry',
        type: String,
        validators: [],
        labelKey: 'in_registry',
      },
      {
        name: 'vehicle_registry_number',
        type: String,
        validators: [],
        labelKey: 'number',
      },
      {
        name: 'driver_license_expiring',
        type: String,
        validators: [],
        labelKey: 'validity_licenses',
      },
      {
        name: 'last_coordinate',
        type: String,
        validators: [],
        labelKey: 'last_coordinate',
      },
      {
        name: 'latitude_from',
        type: String,
        validators: [],
        labelKey: 'latitude_from',
      },
      {
        name: 'latitude_to',
        type: String,
        validators: [],
        labelKey: 'latitude_to',
      },
      {
        name: 'longitude_from',
        type: String,
        validators: [],
        labelKey: 'longitude_from',
      },
      {
        name: 'longitude_to',
        type: String,
        validators: [],
        labelKey: 'longitude_to',
      },
      {
        name: 'last_speed',
        type: String,
        validators: [],
        labelKey: 'speed',
      },
      {
        name: 'speed_from',
        type: String,
        validators: [],
        labelKey: 'speed_from',
      },
      {
        name: 'speed_to',
        type: String,
        validators: [],
        labelKey: 'speed_to',
      },
      {
        name: 'total_travel_time',
        type: String,
        validators: [],
        labelKey: 'travel_time',
      },
      {
        name: 'travel_time_from',
        type: String,
        validators: [],
        labelKey: 'travel_time_from',
      },
      {
        name: 'travel_time_to',
        type: String,
        validators: [],
        labelKey: 'travel_time_to',
      },
      {
        name: 'vehicle_brand',
        type: String,
        validators: [],
        labelKey: 'vehicle_brand',
      },
      {
        name: 'vehicle_model',
        type: String,
        validators: [],
        labelKey: 'vehicle_model',
      },
      {
        name: 'vehicle_vin',
        type: String,
        validators: [],
        labelKey: 'vehicle_vin',
      },
      {
        name: 'vehicle_color',
        type: String,
        validators: [],
        labelKey: 'vehicle_color',
      },
      {
        name: 'location_applicant_role',
        type: String,
        validators: [],
        labelKey: 'location_applicant_role',
      },
      {
        name: 'is_illegal',
        type: String,
        validators: [],
        labelKey: 'is_illegal',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default VehicleRegistryDTO;
